// components/BuscadorClientes.jsx
import React, { useState, useEffect } from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
  Paper,
  Box,
  Chip,
  Tooltip,
  Badge,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import FilterListIcon from '@mui/icons-material/FilterList';

const BuscadorClientes = ({ data, onFilter, placeholder = "Buscar cliente..." }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCount, setFilteredCount] = useState(0);
  const [showFilters, setShowFilters] = useState(false);

  // Función de búsqueda mejorada que busca en TODAS las columnas
  const filterData = (term) => {
    if (!term.trim()) {
      onFilter(data); // Si no hay término de búsqueda, devuelve todos los datos
      setFilteredCount(0);
      return;
    }

    const searchTermLower = term.toLowerCase().trim();
    
    const filtered = data.filter(item => {
      // Buscar en TODAS las propiedades del objeto
      return Object.values(item).some(value => {
        if (value === null || value === undefined) return false;
        
        // Convertir a string y buscar
        return value.toString().toLowerCase().includes(searchTermLower);
      });
    });

    setFilteredCount(filtered.length);
    onFilter(filtered);
  };

  // Manejar cambios en el input
  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    filterData(term);
  };

  // Limpiar búsqueda
  const handleClearSearch = () => {
    setSearchTerm('');
    filterData('');
  };

  // Actualizar cuando cambien los datos originales
  useEffect(() => {
    filterData(searchTerm);
  }, [data]); // Re-filtrar si los datos originales cambian

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
      <Paper
        elevation={0}
        sx={{
          p: '2px 4px',
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          maxWidth: 500,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          bgcolor: 'background.paper',
        }}
      >
        <InputAdornment position="start" sx={{ ml: 1 }}>
          <SearchIcon color="action" />
        </InputAdornment>
        
        <TextField
          fullWidth
          variant="standard"
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleSearchChange}
          InputProps={{
            disableUnderline: true,
            sx: { ml: 1, fontSize: '0.95rem' }
          }}
          size="small"
        />
        
        {searchTerm && (
          <Tooltip title="Limpiar búsqueda">
            <IconButton onClick={handleClearSearch} size="small" sx={{ mr: 1 }}>
              <ClearIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        
        
      </Paper>
      
      {/* {searchTerm && (
        <Chip
          label={`${filteredCount} de ${data?.length || 0} resultados`}
          size="small"
          color="primary"
          variant="outlined"
          onDelete={handleClearSearch}
        />
      )} */}
    </Box>
  );
};

export default BuscadorClientes;